import { cn } from "@edusogno/lib/utils";
import React from "react";

interface Props {
  children?: React.ReactNode;
  className?: string;
}

const RegistrationContent = ({ children, className }: Props) => {
  return (
    <div
      className={cn(
        "flex flex-col flex-[1_1_100%]  3xl:pt-12 w-full gap-4 h-full",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default RegistrationContent;
